(function () {
  // Prevent multiple initializations if the file is included twice
  if (window.__wcagCookieBannerInit) return;
  window.__wcagCookieBannerInit = true;

  try {
    var BANNER_ID = 'shopify-pc__banner';
    var TITLE_ID  = 'shopify-pc__banner__body-title';
    var ACCEPT_ID = 'shopify-pc__banner__btn-accept';
    var DECLINE_ID= 'shopify-pc__banner__btn-decline';
    var MANAGE_ID = 'shopify-pc__banner__btn-manage-prefs';

    function setAttrIf(el, name, value){
      if (el.getAttribute(name) !== value) el.setAttribute(name, value);
    }

    function getFocusable(container){
      try {
        return Array.prototype.slice.call(container.querySelectorAll(
          'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
        ));
      } catch (_) { return []; }
    }

    function ensureAria(banner){
      // Minimal WCAG 2.1 AA semantics; only set when different
      setAttrIf(banner, 'role', 'dialog');
      setAttrIf(banner, 'aria-modal', 'true');
      if (!banner.getAttribute('aria-labelledby')) setAttrIf(banner, 'aria-labelledby', TITLE_ID);

      var desc = banner.querySelector('.shopify-pc__banner__body p');
      if (desc) {
        if (!desc.id) desc.id = 'shopify-pc__banner__body-desc';
        setAttrIf(banner, 'aria-describedby', desc.id);
      }
      if (!banner.hasAttribute('tabindex')) banner.setAttribute('tabindex', '-1');
    }

    // When Esc is pressed, move focus to main content (or previous element)
    function focusMainOrPrevious(prev) {
      try {
        var main =
          document.querySelector('[role="main"]') ||
          document.getElementById('MainContent') ||
          document.getElementById('main-content');
        if (main && typeof main.focus === 'function') {
          if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
          main.focus();
          return true;
        }
      } catch (_) {}
      if (prev && typeof prev.focus === 'function') { prev.focus(); return true; }
      // Last resort: focus body so SRs exit dialog context
      if (document.body && typeof document.body.focus === 'function') {
        if (!document.body.hasAttribute('tabindex')) document.body.setAttribute('tabindex', '-1');
        document.body.focus();
        return true;
      }
      return false;
    }

    function trapFocus(banner, previouslyFocused){
      function onKeydown(e){
        try {
          if (e.key === 'Escape') {
            // AA: keep banner open; move focus out to main (fallbacks handled)
            focusMainOrPrevious(previouslyFocused);
            return;
          }
          if (e.key !== 'Tab') return;

          var list = getFocusable(banner).filter(function(el){
            var cs = getComputedStyle(el);
            return cs.display !== 'none' && cs.visibility !== 'hidden';
          });
          if (!list.length){ e.preventDefault(); banner.focus(); return; }

          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        } catch (_) {}
      }

      banner.__wcagTrap = onKeydown;
      banner.addEventListener('keydown', onKeydown);

      function release(){
        try {
          banner.removeEventListener('keydown', onKeydown);
          // Return focus to where it came from (or main via Esc path above)
          if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
        } catch (_) {}
      }

      [ACCEPT_ID, DECLINE_ID, MANAGE_ID].forEach(function(id){
        var btn = document.getElementById(id);
        if (btn) btn.addEventListener('click', release, { once: true });
      });

      // Observe ONLY this banner’s visibility; not role/aria to avoid loops
      var mo = new MutationObserver(function(){
        try {
          var cs = getComputedStyle(banner);
          var hidden = cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0';
          if (hidden) { release(); mo.disconnect(); }
        } catch (_) {}
      });
      mo.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    function wireWhenVisible(banner){
      if (banner.__wcagWiredVisible) return;

      var cs = getComputedStyle(banner);
      var visible = cs.display !== 'none' && cs.visibility !== 'hidden';
      if (!visible) return;

      banner.__wcagWiredVisible = true;
      var prev = document.activeElement;
      banner.focus();
      trapFocus(banner, prev);
    }

    function setup(banner){
      if (!banner || banner.__wcagSetup) return;
      banner.__wcagSetup = true;

      // One-time ARIA semantics; no observation of aria/role attributes
      ensureAria(banner);

      // Initial visible check + wire
      wireWhenVisible(banner);

      // Watch ONLY this banner’s visibility to wire focus trap later if needed
      var visMo = new MutationObserver(function(){
        try { wireWhenVisible(banner); } catch (_) {}
      });
      visMo.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    function findAndSetup(){
      var banner = document.getElementById(BANNER_ID);
      if (banner) { setup(banner); return true; }
      return false;
    }

    // Bounded polling to find app-injected banner; no global observers
    function start(){
      var attempts = 0, max = 60; // ~15s at 250ms
      var timer = setInterval(function(){
        try {
          if (findAndSetup() || ++attempts >= max) clearInterval(timer);
        } catch (_) { clearInterval(timer); }
      }, 250);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') start();
    else document.addEventListener('DOMContentLoaded', start);

  } catch (_) { /* swallow */ }
})();


